"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState, useEffect, useMemo } from "react";
import dynamic from "next/dynamic";
import { BrandedHeader } from "@/components/branded/headers/BrandedHeader";
import type { ResolvedHeaderColors } from "@/features/theme/resolveBrandedStyle";
import { PageNavigation } from "@/components/layout/PageNavigation";
import { OverviewTab } from "../tabs/OverviewTab";
import { usePlayerPageData } from "../context/PlayerPageDataContext";
import { AdSlot } from "@/features/ads/AdSlot";
import { useLabels } from "@/lib/labels/LabelsProvider";
import { useTenantSettings } from "@/lib/tenant/TenantSettingsProvider";
const StatsTab = dynamic(() => import("../tabs/StatsTab/StatsTab").then(mod => mod.StatsTab));
const NewsTab = dynamic(() => import("../tabs/NewsTab").then(mod => mod.NewsTab));
const FansTab = dynamic(() => import("../tabs/FansTab").then(mod => mod.FansTab));
const VideosTab = dynamic(() => import("../tabs/VideosTab/VideosTab").then(mod => mod.VideosTab));
type Tab = "overview" | "stats" | "news" | "videos" | "fans";
export function Player(t0) {
  const $ = _c(63);
  const {
    headerColors,
    breadcrumbs
  } = t0;
  const [activeTab, setActiveTab] = useState("overview");
  const {
    player,
    hasAnyVideos
  } = usePlayerPageData();
  const labels = useLabels().playerPage;
  const showFansTab = useTenantSettings().features.authentication.enabled;
  let t1;
  if ($[0] !== player.teams) {
    t1 = player.teams?.find(_temp) ?? player.teams?.[0];
    $[0] = player.teams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const currentTeam = t1;
  const positions = labels.info.positions;
  let t2;
  if ($[2] !== player.position) {
    t2 = player.position?.toLowerCase();
    $[2] = player.position;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const positionKey = t2 as keyof typeof positions | undefined;
  const positionLabel = positionKey && positions[positionKey] || player.position || "";
  const teamName = currentTeam?.name || "";
  let t3;
  if ($[4] !== positionLabel || $[5] !== teamName) {
    t3 = [positionLabel, teamName].filter(Boolean);
    $[4] = positionLabel;
    $[5] = teamName;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const subtitle = t3.join(" \xB7 ");
  let t4;
  if ($[7] !== hasAnyVideos) {
    t4 = hasAnyVideos();
    $[7] = hasAnyVideos;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const showVideosTab = t4;
  let t5;
  if ($[9] !== labels.tabs.overview) {
    t5 = {
      id: "overview",
      label: labels.tabs.overview
    };
    $[9] = labels.tabs.overview;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== labels.tabs.stats) {
    t6 = {
      id: "stats",
      label: labels.tabs.stats
    };
    $[11] = labels.tabs.stats;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== labels.tabs.news) {
    t7 = {
      id: "news",
      label: labels.tabs.news
    };
    $[13] = labels.tabs.news;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let baseTabs;
  if ($[15] !== labels.tabs || $[16] !== showFansTab || $[17] !== showVideosTab || $[18] !== t5 || $[19] !== t6 || $[20] !== t7) {
    baseTabs = [t5, t6, t7];
    if (showVideosTab) {
      const t8 = (labels.tabs as any).videos || "Videos";
      let t9;
      if ($[22] !== t8) {
        t9 = {
          id: "videos",
          label: t8
        };
        $[22] = t8;
        $[23] = t9;
      } else {
        t9 = $[23];
      }
      baseTabs.push(t9);
    }
    if (showFansTab) {
      let t8;
      if ($[24] !== labels.tabs.fans) {
        t8 = {
          id: "fans",
          label: labels.tabs.fans
        };
        $[24] = labels.tabs.fans;
        $[25] = t8;
      } else {
        t8 = $[25];
      }
      baseTabs.push(t8);
    }
    $[15] = labels.tabs;
    $[16] = showFansTab;
    $[17] = showVideosTab;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = baseTabs;
  } else {
    baseTabs = $[21];
  }
  const tabs = baseTabs;
  let t8;
  let t9;
  if ($[26] !== tabs) {
    t8 = () => {
      const hash = window.location.hash.slice(1) as Tab;
      if (hash && tabs.some(tab => tab.id === hash)) {
        setActiveTab(hash);
      }
    };
    t9 = [tabs];
    $[26] = tabs;
    $[27] = t8;
    $[28] = t9;
  } else {
    t8 = $[27];
    t9 = $[28];
  }
  useEffect(t8, t9);
  let t10;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = tabId => {
      setActiveTab(tabId);
      window.history.pushState(null, "", `#${tabId}`);
    };
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  const handleTabChange = t10;
  const t11 = player.assets?.profilePhoto || player.assets?.photo || player.assets?.logo;
  const t12 = headerColors?.colors;
  const t13 = headerColors?.backgroundImageUrl;
  let t14;
  if ($[30] !== breadcrumbs || $[31] !== player.name || $[32] !== subtitle || $[33] !== t11 || $[34] !== t12 || $[35] !== t13) {
    t14 = <BrandedHeader titleAs="h1" title={player.name} subtitle={subtitle} imageUrl={t11} colors={t12} backgroundImageUrl={t13} breadcrumbs={breadcrumbs} />;
    $[30] = breadcrumbs;
    $[31] = player.name;
    $[32] = subtitle;
    $[33] = t11;
    $[34] = t12;
    $[35] = t13;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  let t15;
  if ($[37] !== activeTab || $[38] !== tabs) {
    t15 = <PageNavigation options={tabs} activeId={activeTab} onChange={handleTabChange} sticky={true} />;
    $[37] = activeTab;
    $[38] = tabs;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  let t16;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <AdSlot id="content-top" />;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  let t17;
  if ($[41] !== activeTab) {
    t17 = activeTab === "overview" && <OverviewTab />;
    $[41] = activeTab;
    $[42] = t17;
  } else {
    t17 = $[42];
  }
  let t18;
  if ($[43] !== activeTab) {
    t18 = activeTab === "stats" && <StatsTab />;
    $[43] = activeTab;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  let t19;
  if ($[45] !== activeTab) {
    t19 = activeTab === "news" && <NewsTab />;
    $[45] = activeTab;
    $[46] = t19;
  } else {
    t19 = $[46];
  }
  let t20;
  if ($[47] !== activeTab) {
    t20 = activeTab === "videos" && <VideosTab />;
    $[47] = activeTab;
    $[48] = t20;
  } else {
    t20 = $[48];
  }
  let t21;
  if ($[49] !== activeTab || $[50] !== showFansTab) {
    t21 = activeTab === "fans" && showFansTab && <FansTab />;
    $[49] = activeTab;
    $[50] = showFansTab;
    $[51] = t21;
  } else {
    t21 = $[51];
  }
  let t22;
  if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <AdSlot id="content-bottom" />;
    $[52] = t22;
  } else {
    t22 = $[52];
  }
  let t23;
  if ($[53] !== t17 || $[54] !== t18 || $[55] !== t19 || $[56] !== t20 || $[57] !== t21) {
    t23 = <div className="max-w-350 mx-auto px-4 py-8 space-y-8">{t16}{t17}{t18}{t19}{t20}{t21}{t22}</div>;
    $[53] = t17;
    $[54] = t18;
    $[55] = t19;
    $[56] = t20;
    $[57] = t21;
    $[58] = t23;
  } else {
    t23 = $[58];
  }
  let t24;
  if ($[59] !== t14 || $[60] !== t15 || $[61] !== t23) {
    t24 = <div className="min-h-screen">{t14}{t15}{t23}</div>;
    $[59] = t14;
    $[60] = t15;
    $[61] = t23;
    $[62] = t24;
  } else {
    t24 = $[62];
  }
  return t24;
}
function _temp(t) {
  return t.type === "club";
}